import React from 'react';
import { styled } from '@linaria/react';
import { SizesType } from 'types/Sizes';
import { ColorPath } from 'types/Theme';
import { cssTheme } from '../../../themes';
import { getCssColorByPath } from '../../../utils/colors';
type HorizontalProgressSize = Extract<SizesType, 'xs' | 'sm'>;
interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** The fill percentage of the bar */
  value: number;
  /** Specify the color path from the theme's colors file to explicitly set the bar's color */
  colorPath?: ColorPath;
  /** The height of the bar */
  size?: HorizontalProgressSize;
  /** Whether the bar should have rounded corners */
  rounded?: boolean;
}
const _exp = /*#__PURE__*/() => ({
  size
}) => ({
  xs: 2,
  sm: 4
})[size];
const _exp2 = /*#__PURE__*/() => ({
  rounded
}) => rounded ? cssTheme.layout.radius.rounded : 0;
export const HorizontalProgressBarElement = /*#__PURE__*/styled('div')({
  name: "HorizontalProgressBarElement",
  class: "htgfb2v",
  propsAsIs: false,
  vars: {
    "htgfb2v-0": [_exp(), "px"],
    "htgfb2v-1": [_exp2()]
  }
});
const _exp4 = /*#__PURE__*/() => ({
  colorValue,
  value
}) => colorValue ? colorValue : barColor({
  value
});
const _exp5 = /*#__PURE__*/() => ({
  rounded
}) => rounded ? cssTheme.layout.radius.rounded : '0px';
const _exp6 = /*#__PURE__*/() => ({
  value
}) => `${value}%`;
export const HorizontalProgressBarValue = /*#__PURE__*/styled('div')({
  name: "HorizontalProgressBarValue",
  class: "huuzvim",
  propsAsIs: false,
  vars: {
    "huuzvim-0": [_exp4()],
    "huuzvim-1": [_exp5()],
    "huuzvim-2": [_exp6()]
  }
});
const barColor = ({
  value
}: {
  value: number;
}) => {
  if (value >= 70) return cssTheme.colors.scoreBar.indicator.success;
  return cssTheme.colors.scoreBar.indicator.neutral;
};
export const HorizontalProgressBar = ({
  value,
  size = 'sm',
  colorPath,
  className,
  rounded = true
}: Props) => {
  const colorValue = colorPath && getCssColorByPath(colorPath);
  return <HorizontalProgressBarElement size={size} className={className} rounded={rounded}>
      <HorizontalProgressBarValue rounded={rounded} value={value} colorValue={colorValue} />
    </HorizontalProgressBarElement>;
};

require("./HorizontalProgressBar.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HorizontalProgressBar.tsx");